import axios from "axios";

export default function ReceiptFileGetService(receiptId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptId + "/getBase64ExternalFile",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
